/* @flow */

import Body from './body'
import Headers from './headers'

class Response extends Body {
  type: string
  url: string
  status: number
  ok: boolean
  statusText: string
  headers: Headers

  constructor(bodyInit: string, options: ?Object) {
    super()
    if (!options) {
      options = {}
    }

    this._initBody(bodyInit)
    this.type = 'default'
    this.url = options.url || ''
    this.status = options.status
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = options.statusText
    this.headers = options.headers instanceof Headers ? options.headers : new Headers(options.headers)
  }
}
export default Response
